import axios from 'axios';
import { getEnv } from '../config';

const API_URL = getEnv('REACT_APP_API_URL') || '';

export const serviceAPI = {
    createService: (data) => axios.post(`${API_URL}/api/services`, data),
    getServices: (params) => axios.get(`${API_URL}/api/services`, { params }),
    getService: (id) => axios.get(`${API_URL}/api/services/${id}`),
    updateService: (id, data) => axios.put(`${API_URL}/api/services/${id}`, data),
    getReport: (params) => axios.get(`${API_URL}/api/services/reports`, { params }),
    getCurrentService: () => axios.get(`${API_URL}/api/services/current`),
    getRecentServices: () => axios.get(`${API_URL}/api/services/recent`),
    toggleAttendance: (serviceId, data) => axios.post(`${API_URL}/api/services/${serviceId}/attendance`, data),
    updateAbsenceReason: (serviceId, data) => axios.put(`${API_URL}/api/services/${serviceId}/absence-reason`, data),
    streamUrl: (serviceId) => {
        const token = localStorage.getItem('token');
        const base = API_URL || window.location.origin;
        return `${base}/api/services/${serviceId}/stream?token=${encodeURIComponent(token)}`;
    },
};
